<template>
	<cus-header>
		<div class="login-container flex" v-loading="loading">
			<div class="left flex-center">
				<img src="../../assets/login/left_image.png" alt="" />
			</div>
			<div class="right">
				<div class="flex-center">
					<div class="head">
						欢迎登录
					</div>
				</div>

				<div class="content">
					<div style="color:red;text-align: center;margin-top:-40px;margin-bottom: 40px;">正在升级中</div>
					<div class="input-content">
						<el-input placeholder="请输入手机号" maxlength="11" v-model="form.phone">
							<div class="input-prefix col-center" slot="prefix">
								<div class="input-icon">
									<img src="../../assets/login/user.png" alt="" />
								</div>
							</div>
						</el-input>
					</div>
					<div class="input-content">
						<el-input placeholder="请输入密码" v-model="form.password" show-password>
							<div class="input-prefix col-center" slot="prefix">
								<div class="input-icon">
									<img src="../../assets/login/password.png" alt="" />
								</div>
							</div>
						</el-input>
					</div>
					<div class="input-content flex-sb remember">
						<div> <el-checkbox v-model="checked">记住密码</el-checkbox></div>
						<!-- <div class="forget" @click="$router.push('/forget')">忘记密码？</div> -->
					</div>
					<div class="floor row-center">
						<el-dropdown style="width:100%" split-button type="primary" @command="handleCommand"
							@click="login">
							{{command == '1' ? '学生/专家登录' : '校级管理员登录'}}
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="1">学生/专家登录</el-dropdown-item>
								<el-dropdown-item command="2">校级管理员登录</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</div>

				<div class="flex-center register">
					<div>还没账号？</div>
					<div class="link" @click="$router.push('/register')">参赛团队注册(队长)注册</div>
					<div style="padding:0 10px;">/</div>
					<div class="link" @click="$router.push('/register?type=school')">校级管理员注册</div>
				</div>
			</div>
		</div>
		<el-dialog title="绑定高校/学院" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
			<div class="tips">您的账号还未绑定高校/学院，请选择高校/学院绑定后进入！<br>绑定后不可修改，如遇特殊情况请联系管理员！</div>
			<el-select style="width:100%;" v-model="school_id" filterable remote reserve-keyword
				placeholder="输入查询所属高校/学院" :remote-method="remoteMethod" :loading="universityLoading">
				<el-option v-for="item in universityOptions" :key="item.id" :label="item.name" :value="item.id">
				</el-option>
			</el-select>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="bindSchoolFun">确 定</el-button>
			</span>
		</el-dialog>
	</cus-header>
</template>

<script>
	import Vue from 'vue'
	// import Cookie from 'js-cookie';
	import CryptoJS from 'crypto-js';
	import {
		login,
		bindUserSchool,
		schoolLogin
	} from '@/common/api/user.js'
	import {
		getUniversityList
	} from '@/common/api/public.js'
	// 获取本地地址
	let urlRes = ''
	urlRes = window.location.protocol + "//" + window.location.host
	if (urlRes.indexOf('localhost') !== -1) {
		urlRes = 'http://10.0.7.202:8686'
	}
	export default {
		name: '',
		props: {

		},
		components: {

		},
		data() {
			return {
				checked: false,
				loading: false,
				dialogVisible: false,
				bindData: {},
				universityLoading: false,
				universityOptions: [],
				school_id: '',
				form: {
					phone: "",
					password: ""
				},
				command: '1'
			}
		},
		created() {
			let userinfo = localStorage.getItem("userinfo")
			if (userinfo && userinfo !== "{}") {
				userinfo = JSON.parse(userinfo)
				this.form.phone = userinfo.phone
			}
			if (localStorage.getItem("checked") === '1') {
				this.checked = true
				let userPass = localStorage.getItem('userPass')
				if (userPass && userPass !== '{}') {
					this.form = JSON.parse(this.decryptData(userPass))
				}
			}
			let commandLocal = localStorage.getItem("commandLocal")
			if (commandLocal == '2') {
				this.command = 2
			}
		},
		mounted() {

		},
		methods: {
			async login() {
				// if (this.command == "1") {
				// 	return this.$message.warning('系统暂未开放')
				// }
				 // if (this.form.username === 'admin') {
				// 	localStorage.setItem("userinfo", JSON.stringify({
				// 		username: "admin",
				// 		name: "李铁柱",
				// 		rule: 'expert'
				// 	}))
				// 	Vue.prototype.authority = 'expert'
				// } else {
				// 	localStorage.setItem("userinfo", JSON.stringify({
				// 		username: "",
				// 		name: "张全蛋",
				// 		rule: ''
				// 	}))
				// 	Vue.prototype.authority = ''
				// }
				// this.$alert('系统维护升级中…', '提示', {
				// 	confirmButtonText: '确定',
				// 	callback: action => {}
				// });
				// return
				if (!this.form.phone) {
					return this.$message.error('请输入手机号')
				}
				if (!this.form.password) {
					return this.$message.error('请输入密码')
				}

				let fun = null,
					pram = {};
				if (this.command == "2") {
					fun = schoolLogin
					pram = {
						mobile: this.form.phone,
						password: this.form.password
					}
				} else {
					fun = login
					pram = {
						phone: this.form.phone,
						password: this.form.password
					}
				}
				this.loading = true
				try {
					const {
						data
					} = await fun(pram)
					this.loading = false;
					if (this.command == "2") {
						this.$message.success('登录成功')
						if (this.checked) {
							localStorage.setItem("checked", '1')
							localStorage.setItem('userPass', this.encryptData(JSON.stringify(this.form)))
							// Cookie.set('userPass', JSON.stringify(this.form));
						} else {
							localStorage.setItem("checked", '0')
							localStorage.setItem('userPass', '')
						}
						setTimeout(() => {
							window.location.href = urlRes + data.url + "?token=" + data.token

						}, 1000)
						console.log(data, '成功')

						return
					}

					if (data.is_bind == 1) {
						this.bindData = data
						this.dialogVisible = true
						return
					}
					this.jumpHome(data)
				} catch (e) {
					this.loading = false
					// this.$message.error(JSON.stringify(e.message));
					console.log(e)
					//TODO handle the exception
				}

			},
			// 跳转登录
			jumpHome(data) {
				if (data.role_type == 1) {
					Vue.prototype.authority = ''
				} else {
					data.rule = 'expert'
					Vue.prototype.authority = 'expert'
				}

				localStorage.setItem("userinfo", JSON.stringify(data))
				localStorage.setItem("access_token", data.access_token)
				localStorage.setItem("refresh_token", data.refresh_token)
				this.$message.success('登录成功')
				if (this.checked) {
					localStorage.setItem("checked", '1')
					localStorage.setItem('userPass', this.encryptData(JSON.stringify(this.form)))
					// Cookie.set('userPass', JSON.stringify(this.form));
				} else {
					localStorage.setItem("checked", '0')
					localStorage.setItem('userPass', '')
				}
				setTimeout(() => {
					this.$router.push('/index')
				}, 1000)
			},
			encryptData(data) {
				const secretKey = 'fujun-review' // 密钥应该是秘密的，不要在代码中硬编码
				return CryptoJS.AES.encrypt(data, secretKey).toString()
			},
			decryptData(data) {
				const secretKey = 'fujun-review'
				const bytes = CryptoJS.AES.decrypt(data, secretKey)
				return bytes.toString(CryptoJS.enc.Utf8)
			},
			// 查询高校
			async remoteMethod(query) {
				if (query !== '') {
					this.universityLoading = true;
					const {
						data
					} = await getUniversityList({
						key_words: query,
						per_page: 20
					})
					this.universityOptions = data.data
					this.universityLoading = false
					console.log(this.universityOptions, 1111111111)
				}
			},
			handleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						done();
					})
					.catch(_ => {});
			},
			// 绑定高校
			async bindSchoolFun() {
				if (!this.school_id) {
					return this.$message.error('请选择绑定的高校')
				}
				localStorage.setItem("access_token", this.bindData.access_token)
				localStorage.setItem("refresh_token", this.bindData.refresh_token)
				this.loading = true
				try {
					const {
						data
					} = await bindUserSchool({
						school_id: this.school_id
					})
					this.loading = false
					this.jumpHome(this.bindData)
				} catch (e) {
					this.loading = false
					//TODO handle the exception
				}
			},
			handleCommand(e) {
				this.command = e
				localStorage.setItem('commandLocal', e)
			}
		}

	}
</script>

<style lang="scss" scoped>
	.login-container {
		border-radius: 0.625rem;
		overflow: hidden;
		box-shadow: 2px 4px 10px 4px rgba(92, 140, 199, .2);

		.left {
			width: 36.25rem;
			margin-right: -1px;

			// height: 43.75rem;
			img {
				width: 100%;
				margin-top: -4px;
			}
		}

		.right {
			flex-grow: 1;
			width: 0;
			background-color: white;
			padding: 2.5rem 7rem;

			.head {
				font-size: 1.35rem;
				font-weight: bold;
				position: relative;
				padding-top: 1.875rem;
				padding-left: 3rem;
				padding-right: 3rem;
				margin: 0 auto;
				color: #378DF7;
			}

			.head::after {
				content: "";
				display: block;
				width: 1.0416rem;
				height: 1.0416rem;
				position: absolute;
				left: .5rem;
				background: url(../../assets/login/left.png);
				bottom: .3rem;
			}

			.head::before {
				content: "";
				display: block;
				width: 1.0416rem;
				height: 1.0416rem;
				position: absolute;
				right: .5rem;
				background: url(../../assets/login/right.png);
				bottom: .3rem;
			}

			.content {
				padding-top: 4rem;

				::v-deep .el-input__inner {
					height: 3.75rem;
					padding-left: 5rem;
					font-size: 1rem;
				}

				::v-deep .el-icon-view:before {
					font-size: 1.125rem;
					position: absolute;
					right: 0.5rem;
					top: 0.5rem;
				}

				.remember {
					padding-bottom: 3rem;
					font-size: 0.875rem;

					.forget {
						cursor: pointer;
						color: #4389E0;
					}

					.forget:hover {
						text-decoration: underline;
					}
				}

				.input-content {
					margin-bottom: 2rem;

					.input-prefix {
						position: relative;
						height: 100%;
						padding: 0 1.25rem;

						.input-icon {
							width: 1.125rem;
						}
					}

					.input-prefix::after {
						position: absolute;
						content: "";
						right: 0;
						height: 1.5rem;
						margin-top: -0.75rem;
						top: 50%;
						display: block;
						width: 1px;
						background-color: #DDDEE2;
					}
				}
			}

			.floor {
				width: 100%;

				::v-deep .el-button-group {
					display: flex;
				}

				::v-deep .el-button {
					// width: 100%;
					flex-grow: 1;
					width: 0;
					height: 3.5rem;
					background: #358BF6;
					box-shadow: 1px 0.375rem 1.875rem 0px rgba(0, 114, 255, 0.3);
					border-radius: 0.25rem;
					color: white;
					font-size: 1rem;
				}

				::v-deep .el-button.el-button--primary.el-dropdown__caret-button {
					flex-grow: 0;
					width: 50px;
				}
			}

			.register {
				padding-top: 1.875rem;
				color: #949BB0;

				.link {
					color: #4389E0;
					cursor: pointer;
				}

				.link:hover {
					text-decoration: underline;
				}
			}
		}
	}

	.tips {
		font-size: 18px;
		color: red;
		padding-bottom: 30px;
	}

	::v-deep() {

		.el-dialog__close.el-icon.el-icon-close,
		.el-dialog__title {
			color: white;
		}

	}

	// 响应式

	@media screen and (min-width: 1200px) {}

	@media screen and (min-width: 923px) and (max-width:1199px) {}

	@media screen and (min-width: 768px) and (max-width:922px) {}

	@media screen and (max-width: 922px) {
		.login-container {
			box-shadow: 2px 4px 10px 4px rgba(92, 140, 199, 0);

			.left {
				display: none;
			}

			.right {
				padding: 1rem 2.5rem;

				.content {
					padding-top: 2.5rem;

					.remember {
						padding-top: 2rem;
					}
				}
			}
		}
	}
</style>